import { render, staticRenderFns } from "./MedicalTravelers.vue?vue&type=template&id=533a3b51&scoped=true&"
import script from "./MedicalTravelers.vue?vue&type=script&lang=js&"
export * from "./MedicalTravelers.vue?vue&type=script&lang=js&"
import style0 from "./MedicalTravelers.vue?vue&type=style&index=0&id=533a3b51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533a3b51",
  null
  
)

export default component.exports